export { default as UserDetailsOpen } from './Details';